// extracted by mini-css-extract-plugin
export default {"root":"applications-components-common-Description-links-module__root","link":"applications-components-common-Description-links-module__link","active":"applications-components-common-Description-links-module__active"};
    if(module.hot) {
      // 1791528099875
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  